/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CandidateStatusDto = {
    AwaitingDownload: 'AWAITING_DOWNLOAD',
    AwaitingExternalPick: 'AWAITING_EXTERNAL_PICK',
    AwaitingProcessing: 'AWAITING_PROCESSING',
    CheckExternalProcess: 'CHECK_EXTERNAL_PROCESS',
    Downloading: 'DOWNLOADING',
    Error: 'ERROR',
    InsufficientPositionDescription: 'INSUFFICIENT_POSITION_DESCRIPTION',
    Imported: 'IMPORTED',
    InProgress: 'IN_PROGRESS',
    New: 'NEW',
    NoFileFound: 'NO_FILE_FOUND',
    ProcessNotReady: 'PROCESS_NOT_READY',
    ProcessingOutdated: 'PROCESSING_OUTDATED',
    Seen: 'SEEN',
    UnrelatedExperience: 'UNRELATED_EXPERIENCE',
} as const;

export type CandidateStatusDto = typeof CandidateStatusDto[keyof typeof CandidateStatusDto];



